module.exports = __webpack_public_path__ + "static/media/dec-card-graphic@2x.64995848.png";